module.exports = __webpack_public_path__ + "img/poziom11.c6f04e3c.svg";